import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface IYandexApiKeyField {
	settingsId: string;
	onChange: (value: string) => void;
}

const YandexApiKeyField: React.FC<IYandexApiKeyField> = ({ onChange, settingsId }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterApiKey') }], [t]);

	return (
		<FormInput
			testId="YandexApiKeyField"
			name={`yandexApiKey-${settingsId}`}
			label="apiKeyLabel"
			onChange={onChange}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(YandexApiKeyField);
